import { Box, SxProps } from '@mui/material';
import { motion } from 'motion/react';
import { FunctionComponent } from 'react';
import { adaptTransition, AsyncAnimationProps, useAnimationsDisabled } from '../../util/Animation';
import { mergeSx, motionStyleSheet } from '../../util/Styles';


type Props = AsyncAnimationProps & {
	sx?: SxProps;
};

export const GameLogo: FunctionComponent<Props> = (props) => {
	const animationsDisabled = useAnimationsDisabled();

	const LAYERS = {
		Background: '/images/Logo Layer Background.png',
		Spotlights: '/images/Logo Layer Spotlights.png',
		/** Lights are spread across three layers. Rotating between them creates a circular pattern. */
		LightLayers: [
			'/images/Logo Layer Lights 1.png',
			'/images/Logo Layer Lights 2.png',
			'/images/Logo Layer Lights 3.png',
		],
		Text: '/images/Logo Layer Text.png',
	};

	const LIGHT_DURATION = .4;

	return props.show &&
		<Box sx={mergeSx(styles.container, props.sx)}>
			<img src={LAYERS.Background} style={{ ...styles.layer, ...styles.background }} alt='' />
			{LAYERS.LightLayers.map((layer, index) =>
				<motion.img key={index} src={layer} style={styles.layer} alt=''
					initial={{ opacity: index === 0 ? 1 : 0 }}
					animate={animationsDisabled ? { opacity: index === 0 ? 1 : 0 } : { opacity: [0, 1, 0] }}
					transition={adaptTransition({
						duration: LIGHT_DURATION,
						repeat: Infinity,
						delay: index * (LIGHT_DURATION / LAYERS.LightLayers.length),
					})}
				/>
			)}
			<img src={LAYERS.Text} style={styles.layer} alt='' />
			<motion.img src={LAYERS.Spotlights} style={styles.layer} alt=''
				animate={animationsDisabled
					? {
						opacity: 1,
						filter: 'hue-rotate(20deg)'
					}
					: {
						opacity: [1, .9, 1],
						filter: 'hue-rotate(20deg)'
					}}
				transition={animationsDisabled
					? undefined
					: adaptTransition({
						duration: 1,
						repeat: Infinity,
						ease: 'easeInOut',
					})}
			/>
		</Box>;
};

const styles = motionStyleSheet({
	container: {
		position: 'relative',
		width: '100%',
		height: '100%',
		display: 'flex',
	},
	layer: {
		position: 'absolute',
		width: '100%',
		height: '100%',
		objectFit: 'contain',
	},
	background: {
		// Feather edges of background image to blend into background color
		maskImage: 'linear-gradient(to right, transparent 10%, black, transparent 90%)',
	},
});
